
<a-menu
  :style="style"
  class="contextmenu"
  v-show="visible"
  @click="handleClick"
  :selectedKeys="selectedKeys"
>
  <a-menu-item :key="index" v-for="(item, index) in itemList">
    <a-icon role="menuitemicon" v-if="item.icon" :type="item.icon" />{{
      item.text
    }}
  </a-menu-item>
</a-menu>
